(function () {
    document.addEventListener("DOMContentLoaded", () => {

        function wave_fix() {
            const selectors = '.hc-hover-info-image__category-title, .hc-hover-info-image__category-details, .hc-hover-info-image__category-btn, .site-header__left-toggle-wrapper .open, .site-header__left-toggle-wrapper .close, .hc-hero-fullscreen__media-title';
            document.querySelectorAll(selectors).forEach(function (el) {
                el.style.backgroundColor = 'rgba(0, 0, 0, 0.009)';
            });
        }

        wave_fix();
        // header

        window.addEventListener('load', function () {
            setTimeout(function () {
                document.body.classList.add('page-loaded');
            }, 1000);
        });

        let scrollTimeout;

        window.addEventListener("scroll", function () {
            const body = document.body;
            const scrollY = window.scrollY || window.pageYOffset;

            if (scrollY > 10) {
                body.classList.add("scrolled");
            }

            document.documentElement.classList.add("scrolling");

            if (scrollTimeout) clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(() => {
                document.documentElement.classList.remove("scrolling");
            }, 800);
        });

        document.querySelectorAll('.site-header__menu-link').forEach(link => {
            link.addEventListener('click', function (e) {

                const parentItem = this.closest('.site-header__menu-item');
                if (!parentItem) return;

                if (parentItem.classList.contains('menu-item-has-children')) {
                    e.preventDefault();

                    document.querySelectorAll('.site-header__menu-item.open').forEach(item => {
                        if (item !== parentItem) {
                            item.classList.remove('open');
                        }
                    });

                    parentItem.classList.toggle('open');
                }
            });
        });

        const menuToggle = document.querySelector('.site-header__left');
        const menuTogglemobile = document.querySelector('.site-header__mobile-menu-toggle');
        const siteHeader = document.querySelector('.site-header');

        function toggleMenu() {
            siteHeader.classList.toggle('site-header__menu-open');
        }

        if (menuToggle) {
            menuToggle.addEventListener('click', toggleMenu);
        }

        if (menuTogglemobile) {
            menuTogglemobile.addEventListener('click', toggleMenu);
        }

        // header
        document.querySelectorAll('.site-header__menu-list').forEach(function (menuList, menuIndex) {

            var header = menuList.closest('.site-header');

            if (!header) return;

            var menuImgWrap = header.querySelector('.site-header__menu-img');

            if (!menuImgWrap) return;

            var currentMenuImage = null;

            menuList.querySelectorAll('li').forEach(function (li) {

                var imgUrl = li.getAttribute('data-image-url');
                var imageId = li.getAttribute('data-image-id');
                var imageAlt = li.getAttribute('data-image-alt');

                if (!imgUrl || !imageId) return;

                var isCurrent = li.classList.contains('current-menu-item');

                var img = document.createElement('img');
                img.src = imgUrl;
                img.className = 'site-header__menu-list-img';
                if (!imageAlt) {
                    var link = li.querySelector('a');
                    if (link) {
                        imageAlt = link.textContent.trim();
                    }
                }
                img.alt = imageAlt || 'Menu image';
                img.setAttribute('data-id', imageId);
                img.setAttribute('data-menu-index', menuIndex);

                if (isCurrent) {
                    img.classList.add('current-menu');
                    currentMenuImage = img;
                }

                menuImgWrap.appendChild(img);
            });

            var mainImage = document.querySelector('.site-header__menu-list-img[data-id="main-image"]');
            if (mainImage) {
                mainImage.classList.add('is-visible');
            }

            var hasCurrent = false;
            document.querySelectorAll('.site-header__menu-list-img').forEach(function (img) {
                if (img.classList.contains('current-menu')) {
                    document.querySelectorAll('.site-header__menu-list-img').forEach(function (allImg) {
                        allImg.classList.remove('is-visible');
                    });
                    img.classList.add('is-visible');
                    hasCurrent = true;
                }
            });

            menuList.querySelectorAll('li').forEach(function (li) {

                li.addEventListener('mouseenter', function () {

                    var imageId = this.getAttribute('data-image-id');
                    if (!imageId) return;

                    menuImgWrap.querySelectorAll('.site-header__menu-list-img').forEach(function (img) {
                        img.classList.remove('is-visible');
                    });

                    var target = menuImgWrap.querySelector('.site-header__menu-list-img[data-id="' + imageId + '"][data-menu-index="' + menuIndex + '"]');

                    if (target) {
                        target.classList.add('is-visible');
                    }
                });

                li.addEventListener('mouseleave', function () {

                    var hasCurrent = false;

                    menuImgWrap.querySelectorAll('.site-header__menu-list-img').forEach(function (img) {
                        img.classList.remove('is-visible');
                    });

                    document.querySelectorAll('.site-header__menu-list-img').forEach(function (img) {
                        if (img.classList.contains('current-menu')) {
                            img.classList.add('is-visible');
                            hasCurrent = true;
                        }
                    });

                    if (!hasCurrent) {
                        var mainImage = document.querySelector('.site-header__menu-list-img[data-id="main-image"]');
                        if (mainImage) {
                            mainImage.classList.add('is-visible');
                        }
                    }
                });
            });
        });
    });
})();
